import RepositoryRequestMap from '@candybox/repository/request-map.js';
import { singleton } from '@candybox/helpers.js';

export default singleton(() => {
    return new RepositoryRequestMap('/api/users/permissions');
});